module.exports = __webpack_public_path__ + "img/white-info.7004d8d9.svg";